var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCheckmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 12,
  viewBox: "0 0 15 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M1 6.003 6 11l8-10"
})));
export default SvgCheckmark;